import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { FaCheck, FaLayerGroup } from 'react-icons/fa';
import MiniLoadingSpinner from '../../../../../../../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './GroupListSection.scss';

interface ExistingGroup {
  selection_group_id: number;
  selection_group_name: string;
  selection_group_description?: string;
  local_id: number;
  is_new: boolean;
  items_contained: Array<{
    item_id: number;
    item_name: string;
    label: string;
    is_new: boolean;
    price_modifier: number;
    delivery_price_modifier: number;
    online_price_modifier: number;
    desk_price_modifier: number;
    min_selections: number;
    max_selections: number;
  }>;
  total_items_contained: number;
  has_price_modifiers: boolean;
  has_descriptions: boolean;
  has_selection_constraints: boolean;
  configuration_complexity: {
    has_multiple_contained_items: boolean;
    has_complex_pricing: boolean;
    has_selection_rules: boolean;
  };
}

interface GroupListSectionProps {
  loading: boolean;
  filteredGroups: ExistingGroup[];
  selectedGroup: ExistingGroup | null;
  onGroupSelect: (group: ExistingGroup) => void;
}

const GroupListSection: React.FC<GroupListSectionProps> = ({
  loading,
  filteredGroups,
  selectedGroup,
  onGroupSelect
}) => {
  const renderGroupCard = (group: ExistingGroup) => {
    // Get first 4 item names for preview
    const itemNames = group.items_contained.slice(0, 4).map(item => item.item_name);
    const hasMoreItems = group.items_contained.length > 4;

    return (
      <Card 
        key={group.selection_group_id}
        className={`group-card-clean ${selectedGroup?.selection_group_id === group.selection_group_id ? 'selected' : ''}`}
        onClick={() => onGroupSelect(group)}
      >
        <Card.Body>
          <div className="group-header-clean">
            <div className="group-info-clean">
              <h6 className="group-name-clean">{group.selection_group_name}</h6>
              {group.selection_group_description && (
                <p className="group-description-clean">
                  {group.selection_group_description}
                </p>
              )}
            </div>
            {selectedGroup?.selection_group_id === group.selection_group_id && (
              <FaCheck className="selected-icon-clean" />
            )}
          </div>
          
          <div className="group-items-preview-clean">
            <div className="items-badges-clean">
              {itemNames.map((itemName, index) => (
                <Badge key={index} bg="light" text="dark" className="item-badge-clean">
                  {itemName}
                </Badge>
              ))}
              {hasMoreItems && (
                <Badge bg="secondary" className="more-items-badge-clean">
                  +{group.items_contained.length - 4}
                </Badge>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  if (loading) {
    return (
      <div className="groups-loading-clean">
        <MiniLoadingSpinner />
      </div>
    );
  }

  if (filteredGroups.length === 0) {
    return (
      <div className="no-groups-message-clean">
        <FaLayerGroup className="no-groups-icon-clean" />
        <h6>No hay grupos disponibles</h6>
        <p>No se encontraron grupos que coincidan con tu búsqueda</p>
      </div>
    );
  }

  return (
    <div className="groups-list-section-clean">
      <div className="groups-grid-clean">
        {filteredGroups.map(renderGroupCard)}
      </div>
    </div>
  );
};

export default GroupListSection;
